export interface VimeoDetail {
  video_id: number;
  width: number;
  height: number;
  duration: number;
  thumbnail_url: string;
  thumbnail_width: number;
  thumbnail_height: number;
}

const useVimeo = () => {
  const getVimeoVideoDetails = async (videoId) => {
    try {
      const url = `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${videoId}`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      return false;
    }
  };

  const getVimeoVideoDetailsByUrl = async (url: string): Promise<VimeoDetail | undefined> => {
    try {
      const response = await fetch(`https://vimeo.com/api/oembed.json?url=${url}`);
      const data = await response.json();
      return data as VimeoDetail;
    } catch (error) {}
  };

  return { getVimeoVideoDetails, getVimeoVideoDetailsByUrl };
};

export default useVimeo;
